module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<!-- insert title and Breadcrumb templates -->\r\n")
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12 col-lg-12\">\r\n            <h1>Connections - Dashboard</h1>\r\n        </div>\r\n    </div>\r\n    <ol class=\"breadcrumb\"> \r\n        <li class=\"active\">Connections</li>\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-12\">\r\n        <h2>Information</h2>\r\n        <p>Connections are the way the apps communicate with other systems.</p>\r\n        <p>Apps can write data to and read data from\r\n           Databases(SQL Server, MySQL, Oracle and\r\n           Sybase), LDAP Directory Services, Web Services,\r\n           Text Files(CSV) which are treated like databases,\r\n           and other apps themselves.\r\n        </p>\r\n        <p>Connections to Databases, Text Files, and Directory Services require that a Connection Agent be installed on your servers.</p>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-12\">\r\n        <h2>Connections Help</h2>\r\n        <span><a href=\"")
    ; __append(escapeFn(constants.HELP_CONNS_INTEGRATION ))
    ; __append("\" target=\"_blank\">Administering Connections and Integration</a></span><br/>\r\n        <span><a href=\"")
    ; __append(escapeFn(constants.HELP_CONNS ))
    ; __append("\" target=\"_blank\">Creating Connections</a></span><br/>\r\n        <span><a href=\"")
    ; __append(escapeFn(constants.HELP_CONNS_ACTIONS ))
    ; __append("\" target=\"_blank\">Defining Connection Actions</a></span><br/>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}